// extracted by mini-css-extract-plugin
export var scrollArea = "_pj-0";